module.exports = __webpack_public_path__ + "img/pet_daschund.a3600194.svg";